export var Message;
(function (Message) {
    Message["ACCOUNT_DISABLED"] = "Account has been disabled. If you believe this happened in error, please reach out to our support team at support@domainpage.io.";
    Message["API_KEY_REVOKED"] = "API key does not exist.";
    Message["API_KEY_INVALID"] = "API key invalid";
    Message["API_KEY_REQUIRED"] = "API key required";
})(Message || (Message = {}));
